import { ErrorMessage } from "formik";
import "./ErrorField.css";

const ErrorField = ({ name }: { name: string }) => {
  return <ErrorMessage name={name} component="div" className="error-message" />;
};

export default ErrorField;
